// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectDetailsInfo_content__pid8b","hrContent":"ProjectDetailsInfo_hrContent__cJ4Tg"};